export const ENGAGEMENT_STATUSES = [
  "active",
  "at_risk",
  "disengaged",
  "new",
] as const;

export type EngagementStatus = (typeof ENGAGEMENT_STATUSES)[number];
